import { Box } from "@vinomofo/components";
import { GatsbyImage } from "gatsby-plugin-image";

export type TwoUpDarkProps = {
  tiles: Array<{
    title?: string;
    image?: any;
    bodyText?: string;
  }>;
  title?: string;
};

export const TwoUpDark = ({
  tiles,
  title: blockTitle,
}: TwoUpDarkProps): JSX.Element => {
  return (
    <Box color="#fff" p={[0, 0, 30]} mb={40}>
      {blockTitle && (
        <Box
          as="h2"
          textAlign="center"
          fontSize={[30, 30, 42]}
          fontWeight={500}
          fontFamily="heading"
          lineHeight="95%"
          letterSpacing={0}
          padding={[20, 20, 30]}
          marginBottom={20}
          marginTop={20}
        >
          {blockTitle}
        </Box>
      )}
      <Box
        display="grid"
        gridGap={[20, 30, 40]}
        gridTemplateColumns={["1fr", "1fr 1fr"]}
      >
        {tiles.map(({ title, image, bodyText }, i) => (
          <Box
            key={i}
            borderRadius={16}
            overflow="hidden"
            display="flex"
            flexDirection="column"
            height="100%"
            p={[0, 0, 0]}
          >
            {image && (
              <Box
                position="relative"
                width="100%"
                paddingTop="43.7%"
                borderRadius={16}
                overflow="hidden"
                mb={0}
              >
                <Box
                  position="absolute"
                  top={0}
                  left={0}
                  width="100%"
                  height="100%"
                >
                  <GatsbyImage
                    image={image}
                    style={{ width: "100%", height: "100%" }}
                    imgStyle={{
                      objectFit: "cover",
                      width: "100%",
                      height: "100%",
                    }}
                    alt={title}
                  />
                </Box>
              </Box>
            )}
            <Box
              p={[24, 32, 40]}
              display="flex"
              flexDirection="column"
              fontFamily="heading"
              flexGrow={1}
            >
              {title && (
                <Box
                  as="h3"
                  fontSize={[24, 28]}
                  fontWeight={600}
                  mb={2}
                  color="#fff"
                >
                  {title}
                </Box>
              )}
              {bodyText && (
                <Box
                  fontSize={16}
                  fontWeight={400}
                  fontFamily="heading"
                  lineHeight="132%"
                  letterSpacing="1%"
                  color="#AFAFAF"
                >
                  {bodyText}
                </Box>
              )}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
